import * as React from 'react';
import { IGeneralDentalReferral } from '../../../../models/IGeneralDentalReferral';
import { IPatient } from '../../../../models/IPatient';
import { GeneralDentalReferralStatus } from './GeneralDentalReferralStatus';
import { GeneralDentalReferralPatientInformation } from './GeneralDentalReferralPatientInformation';
import { GeneralDentalReferralReferrerInformation } from './GeneralDentalReferralReferrerInformation';
import { GeneralDentalReferralRecipientInformation } from './GeneralDentalReferralRecipientInformation';
import { GeneralDentalReferralInformation } from './GeneralDentalReferralInformation'
import { GeneralDentalReferralOtherInformation } from './GeneralDentalReferralOtherInformation';
import { GeneralDentalReferralCompletionInformation } from './GeneralDentalReferralCompletionInformation';
import { GeneralDentalReferralRejectionInformation } from './GeneralDentalReferralRejectionInformation';

interface IGeneralDentalReferralSections {
    generalDentalReferral: IGeneralDentalReferral;
    generalDentalReferralId?: number;
    patient: IPatient;
    isFetchingGeneralDentalReferral: boolean;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number, refresh: boolean) => void;
}

export const GeneralDentalReferralSections: React.FunctionComponent<IGeneralDentalReferralSections> = ({ generalDentalReferral, generalDentalReferralId, patient, isFetchingGeneralDentalReferral, changeSuccessMessage, changeErrorMessage, getGeneralDentalReferral }) => {

    return (
        <>
            <GeneralDentalReferralStatus generalDentalReferral={generalDentalReferral} />
            {
                generalDentalReferral.reasonForCompletion ?
                    <GeneralDentalReferralCompletionInformation reasonForCompletion={generalDentalReferral.reasonForCompletion} />
                    : null
            }
            {
                generalDentalReferral.reasonForRejection ?
                    <GeneralDentalReferralRejectionInformation reasonForRejection={generalDentalReferral.reasonForRejection} />
                    : null
            }
            <GeneralDentalReferralPatientInformation generalDentalReferral={generalDentalReferral} patient={patient} />
            <GeneralDentalReferralReferrerInformation generalDentalReferral={generalDentalReferral} />
            <GeneralDentalReferralRecipientInformation generalDentalReferral={generalDentalReferral} />
            <GeneralDentalReferralInformation generalDentalReferral={generalDentalReferral} />
            <GeneralDentalReferralOtherInformation generalDentalReferral={generalDentalReferral} isFetchingGeneralDentalReferral={isFetchingGeneralDentalReferral} />
        </>
    )
}